import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { EntityViewLayout } from "../entityLayout/entityViewLayout";
import { getAllGymClassesReport } from "../../store/classes/classesAction";

export const ShowGymClassesReports = () => {
  const cla = useSelector((state) => state.cla);
  const { isLodaing } = useSelector((state) => state.errors);
  const dispatch = useDispatch();

  const tableProps = {
    name: "Classes Report",
    routePath: "/reports/classes",
    addNewText: "Add new classes report",
    isBreadcrumbs: true,
    isAddNew: false,
    isSearch: true,
    isFilters: true,
    isDateFilters: true,
    isTimeFilters: false,
    isPriceFilter: false,
    isCsvConvert: true,
    isExcelConvert: true,
    columns: [
      {
        Header: "S.No",
        id: "row",
        type: "index",
        maxWidth: 75,
      },
      {
        Header: "Image",
        id: "image",
        maxWidth: 150,
        type: "image",
        filterable: false,
      },
      {
        Header: "Class Name",
        accessor: "name",
        paddingTop: "35px",
      },
      {
        Header: "Description",
        accessor: "description",
        paddingTop: "35px",
      },
      {
        Header: "Creation Date",
        accessor: "createdAt",
        paddingTop: "35px",
      },
    ],
  };

  const searchFields = [
    "name",
    "createdAt",
    "description",
    "start_date",
    "end_date",
  ];
  let history = useHistory();

  const csvHeaders = [
    { label: "Class Name", key: "name" },
    { label: "Description", key: "description" },
    { label: "Class Created Date", key: "createdAt" },
  ];

  const excelHeaders = [
    {
      label: "Class Name",
      fieldName: "name",
      valuePath: "name",
    },
    {
      label: "Description",
      fieldName: "description",
      valuePath: "description",
    },
    {
      label: "Class Created Date",
      fieldName: "createdAt",
      valuePath: "createdAt",
    },
  ];

  const customFilter = ({ start_date, end_date }) => {
    dispatch(getAllGymClassesReport(start_date, end_date));
  };

  const clearFilter = () => {
    dispatch(getAllGymClassesReport());
  };

  useEffect(() => {
    dispatch(getAllGymClassesReport());
  }, []);

  return (
    <EntityViewLayout
      isLoading={isLodaing}
      items={cla.classes}
      searchFields={searchFields}
      tableProps={tableProps}
      history={history}
      customFilter={customFilter}
      csvHeaders={csvHeaders}
      excelHeaders={excelHeaders}
      clearFilter={clearFilter}
      csvFilePrefix="gym_classes_report"
    />
  );
};
